<template>
  <div class="intro-wrapper">
    <nav-common :nav="nav"></nav-common>
    <div class="intro-conent">
      <div class="intro-inner">
        <div class="education-list">
          <list-item
            v-for="item in businessList"
            :key="item.id"
            :itemData="item"
            @toPage="getDetail"
          ></list-item>
        </div>
      </div>
    </div>
    <model-page :dataObj="ariList" @nextPage="nextPage"></model-page>
  </div>
</template>
<style scoped>
.intro-conent {
  width: flex;
  background: #e6ecf2;
  padding: 20px 0;
  border: 1px solid #e6ecf2;
  border-radius: 10px;
  box-sizing: border-box;
}
.intro-inner {
  width: 100%;
  padding: 0 30px;
  box-sizing: border-box;
  background: #fff;
}
</style>

<script>
import navCommon from "@/components/views/common/nav.vue";
import listItem from "@/components/views/common/listItem";
import ModelPage from "@/components/views/common/ModelPage";
import { userApi } from "@/api/user.js";
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      ariList: [],
      page: 1,
      count: 10,
      businessList: [],
      search_word: "",
      nav: {
        firsttitle: this.$route.query.type==1?'海洋标准化':this.$route.query.type==2?'海洋计量':'海洋质量监督',
        firstrouteName: "BusinessIntro",
        secondtitle: "",
        secondrouteName: "",
        thirdtitle: "",
        thirdrouteName: ""
      }
    };
  },
  computed: {
    ...mapGetters(["searchVuex"])
  },
  methods: {
    ...mapActions(["setSearch"]),
    workList() {
        const params = {
          id: this.$route.query.workinfoId?this.$route.query.workinfoId:this.$route.query.firstId,
          page: this.page,
          count: this.count,
          search_word: this.search_word
        };
        userApi.workList(params).then(res => {
          this.ariList = res.data;
          this.businessList = res.data.list;
          this.nav.secondtitle = res.data.workname;
          if (this.ariList.total == "1") {
            this.$router.push({
              name: "BusinessDetail",
              query: {
                firstId: this.$route.query.firstId,
                workinfoId: this.$route.query.workinfoId,
                id: this.businessList[0].id,
                type: this.$route.query.type
              }
            });
          }
        });
    },
    nextPage(pageNo) {
      this.page = pageNo;
      this.workList();
      // 重新加载列表
    },
    getDetail(id) {
      this.$router.push({
        name: "BusinessDetail",
        query: {
          firstId: this.$route.query.firstId,
          workinfoId: this.$route.query.workinfoId,
          id: id,
          type: this.$route.query.type
        }
      });
    }
  },
  mounted() {
    this.workList();
  },
  watch: {
    $route(val, oldval) {
      if(val.query.fr==='hd'){
        this.workList();
      }
    },
    searchVuex(newArr, oldArr) {
      this.search_word = newArr;
      if (this.search_word == "") {
        this.workList();
      }
      this.workList();
    }
  },
  components: {
    navCommon,
    listItem,
    ModelPage
  }
};
</script>




// WEBPACK FOOTER //
// src/components/views/BusinessWork/Children/introduction.vue